export default __webpack_public_path__ + "images/XB.27b6cba.png";